module.exports = __webpack_public_path__ + "media/customizations/tehaleh/logo-8429d68a7a8c5972ac15e24bd8cfece0.png";